import { Progress } from "@patient-watch/ui/progress";
import { Siren } from "lucide-react";

import { useProfileCopy } from "@/features/i18n/profileCopy";
import ProfileCallout from "./ProfileCallout";
import useProfileNavigation from "../hooks/useProfileNavigation";
import useProfileProgress from "../hooks/useProfileProgress";

interface Props {
    userId: string;
}

const ProfileProgress = ({ userId }: Props) => {
    const copy = useProfileCopy();
    const { progress, incomplete } = useProfileProgress(userId);
    const { nextAttribute } = useProfileNavigation();

    if (!incomplete || progress == null) {
        return null;
    }

    return (
        <ProfileCallout
            title={copy.incompleteTitle}
            description={copy.incompleteMessage}
            icon={<Siren size={32} />}
            actionLabel={copy.addNextMissingField}
            actionTo={nextAttribute}
        >
            <div className="flex flex-col gap-y-2 pt-2 w-full">
                <p className="font-semibold text-sm">{copy.profileCompletionLabel(progress)}</p>
                <Progress value={progress} />
            </div>
        </ProfileCallout>
    );
};

export default ProfileProgress;
